export const ACCOUNT = "account";
export const EOTP = "eotp";
export const ENTITY_CODE = "entity_code";
export const SUPPLIER_CODE = "supplier_cl";

export const COMMON_HEADINGS = {
  account: "Compte PCOF",
  account_type: "Type de compte",
  account_date: "Date comptable",
  account_dep: "Compte dépréciation",
  account_amo: "Compte amortissement",
  account_group: "Groupe compte",
  account_group_label: "Libellé compte",
  account_groups_j1: "Détail comptes PCOF",
  account_immo: "Compte immobilisation",
  account_label: "Libéllé compte",
  account_label_j1: "Libéllé compte",
  account_label_k1: "Libéllé",
  account_root_1: "Compte PCOF (1)",
  account_root_2: "Compte PCOF (2)",
  account_root_3: "Compte PCOF (3)",
  account_root_4: "Compte PCOF (4)",
  account_sign: "Sens du compte",
  account_target_sign: "Sens théorique",
  ad_enreg: "AFA exercice en cours",
  ad_prevision: "AD prévisionnel",
  affectation: "Affectation",
  amo_code: "Code d'amortissement",
  amo_depr_cumul: "Amo. Cum.",
  amo_depr_ec: "Amo. dépr. EC",
  amo_depr_ep: "Amo. dépréciation EP",
  amo_non_plan_enreg: "Amo.n/planif. enreg.",
  amo_non_plan_man: "Amo.non plan. manuel",
  amo_start_date: "Début amortissement",
  amort: "Amortissements",
  amount: "Montant en devise interne",
  amount_cca: "Montant CCA",
  amount_cond: "NET DC",
  asset_category: "Classe",
  asset_type: "Type objet",
  balance: "Solde",
  balance_6: "Solde 6*",
  balance_7: "Solde 7*",
  balance_40900000: "TVA théorique (40900000)",
  balance_44581000: "Solde (44581000)",
  balance_current_year: "Solde période en cours (€)",
  balance_diff: "Variation",
  balance_diff_prct: "Variation (%)",
  balance_pct: "Variation (%)",
  variation_pct: "Variation (%)",
  variation_net: "Variation",
  balance_partner: "Solde partenaire",
  balance_previous_year: "Solde période précédente (€)",
  balance_total: "Total solde",
  balance_type: "Type balance",
  calc_from: "Début de la période",
  calc_until: "Fin de la période",
  comissioning_date: "Date mise en service",
  contract: "Contrat",
  cumul_acq_value: "Cap/valr. Cum.",
  depreciation: "Dépréciations",
  designation: "Désignation",
  document_currency: "Devise",
  document_date: "Date document",
  document_id: "N° de pièce",
  document_text: "Texte",
  document_type: "Type de pièce",
  due_date: "Date d'échéance",
  entity_code: "Société",
  entity_code_partner: "Société partenaire",
  entity_code_sl: "N° société S/L part.",
  eotp: "Elément OTP",
  eotp_label: "Libellé éOTP",
  evaluation_tab: "Tableau d'évaluation",
  extern_ref: "Référence",
  first_entry_date: "Date référence",
  fiscal_year: "Exercice",
  gross_value: "Valeur brute",
  immo_bs: "Immo BS",
  immo_pl: "Immo PL",
  immo_total: "Simulation",
  immob: "Immob.",
  income: "Résultat",
  initial_input: "Entré à date",
  key_re: "Clé RE",
  man_amount_cca: "Montant CCA",
  man_amount_pca: "Amount PCA",
  man_comment_03: "Commentaire",
  man_comment_b1: "Commentaire",
  man_comment_b2: "Commentaire",
  man_comment_b31: "Commentaire",
  man_comment_b32: "Commentaire",
  man_comment_b33: "Commentaire",
  man_comment_bg: "Commentaire",
  man_comment_b5_1: "Cotrôle manuel",
  man_comment_b5_2: "FNP comptabilisée",
  man_comment_b6: "Commentaire",
  man_comment_b7: "Commentaire",
  man_comment_d11: "Commentaire",
  man_comment_d12: "Commentaire",
  man_comment_d2: "Commentaire",
  man_comment_i1_1: "Commentaire",
  man_comment_i1_2: "Contrôle manuel (OK/KO)",
  man_input_a2: "Solde bancaire",
  man_input_a3_file: "Fichier de suivi",
  man_input_a3_invoice: "Facture",
  man_input_a4: "Echéancier",
  man_input_a5: "Echéancier",
  man_input_a6: "Echéancier",
  man_input_a7: "Echéancier",
  man_input_a8: "Echéancier",
  man_input_b6_1: "Montant FNP client",
  man_input_b6_2: "Montant FNP Mazars",
  man_input_d3: "Montant fichier client",
  man_input_e1: "Montant fichier client",
  man_input_i2_1: "Acompte 1",
  man_input_i2_2: "Acompte 2",
  man_input_i2_3: "Acompte 3",
  man_input_i2_4: "Acompte 4",
  man_input_i2_5: "Solde IS",
  man_input_i2_6: "Provision IS",
  man_input_i2_7: "C3S",
  man_input_j1_affect_rst: "Affectation Rst",
  man_input_j1_augmentation: "Augmentation",
  man_input_j1_diminution: "Diminution",
  man_input_j2: "Fichier Client",
  nb_day_cca: "Nombre jours CCA",
  nb_day_load: "Nombre jours période de charge",
  net_book_value: "VNC",
  object: "Objet",
  partner: "Parteaire S/L",
  posting_key: "Clé comptabilisation",
  quarter_closing_date: "Date clotûre trimestrielle",
  reconciliation_doc: "Pièce de rapprochement",
  reev_cum_val_rempl: "Réév.cum.val.rempl.",
  reev_prev_val_rempl: "Réév.prév.val.rempl.",
  rent_amount: "Montant FNP Loyer REFX",
  status: "Statut",
  supplier_cl: "Compte auxiliaire",
  test_01: "Contrôle",
  test_02: "Contrôle",
  test_03: "Respect du sens théorique",
  test_04: "Contrôle",
  test_05: "Contrôle",
  test_06: "Contrôle",
  test_07: "Contrôle",
  test_a1: "Contrôle",
  test_a2: "Contrôle",
  test_a3_1: "Contrôle",
  test_a3_2: "Contrôle",
  test_a3_diff_file: "Ecart",
  test_a3_diff_invoice: "Ecart",
  test_a4: "Contrôle",
  test_a5: "Contrôle",
  test_a6: "Contrôle",
  test_a7: "Contrôle",
  test_a8: "Contrôle",
  test_b2: "Contrôle",
  test_b2_diff: "Ecart",
  test_b31: "Contrôle",
  test_b32: "Contrôle",
  test_b4_1: "Contrôle",
  test_b4_diff_1: "Ecart",
  test_b4_2: "Contrôle",
  test_b4_diff_2: "Ecart",
  test_b5: "Contrôle",
  test_b6: "Contrôle",
  test_b6_diff: "Ecart",
  test_b7: "Contrôle",
  test_b7_diff: "Ecart",
  test_d12: "Contrôle",
  test_d2: "Contrôle",
  test_d2_diff: "Ecart",
  test_d3: "Contrôle",
  test_d3_diff: "Ecart",
  test_d4: "Contrôle",
  test_d4_diff: "Ecart",
  test_e1: "Contrôle",
  test_e1_diff: "Ecart",
  test_f1: "Contrôle",
  test_f1_diff: "Ecart",
  test_f2: "Contrôle",
  test_i1: "Contrôle",
  test_i21: "Contrôle",
  test_i22: "Contrôle",
  test_i23: "Contrôle",
  test_i21_diff: "Ecart",
  test_i22_diff: "Ecart",
  test_i23_diff: "Ecart",
  test_j1: "Contrôle",
  test_j2: "Contrôle",
  test_j2_diff: "Ecart",
  test_k1: "Contrôle",
  test_k1_diff: "Ecart",
  tva_code: "Code TVA",
  useful_life: "Durée d'utilisation",
  subvention_account: "Compte de subvention",
  qp_account: "QP affectée au résultat",
  balance_131: "Montant Subvention",
  balance_139: "Montant QP affectée",
  test_j31_diff: "Ecart",
  test_j31: "Contrôle",
  man_input_j32_immo_total: "Simulation",
  test_j32_diff: "Ecart",
  test_j32: "Contrôle",
  solde_cloture: "Solde clôture T4",
};

export const COLUMNS_META = {
  ZFIR20: [
    ENTITY_CODE,
    ACCOUNT,
    SUPPLIER_CODE,
    "affectation",
    "extern_ref",
    "document_id",
    "document_type",
    {
      name: "document_date",
      type: "date",
    },
    {
      name: "account_date",
      type: "date",
    },
    "posting_key",
    "document_text",
    {
      name: "amount",
      type: "float64",
    },
    "document_currency",
    "tva_code",
  ],
  balance_generale: [
    ENTITY_CODE,
    ACCOUNT,
    "account_label",
    "balance_current_year",
    "balance_previous_year",
    "balance_diff",
    "balance_diff_prct",
  ],
};

export const getColumnsMeta = (tableName, testId) => {
  const standardColumns = COLUMNS_META[tableName] || [];
  if (["05", "06"].includes(testId)) standardColumns.splice(standardColumns.indexOf("supplier_cl"), 1)
  if (["B2", "B3.1", "D1.1", "05", "06"].includes(testId))
    standardColumns.splice(1, 0, EOTP);
  if (testId === "I1") standardColumns.splice(2, 0, "entity_code_sl");
  if (standardColumns.length) return Array.from(new Set(standardColumns));
  return null;
};

export const MANUAL_CONTROL_DETAIL_COLUMNS = {
  B2: ["man_comment_b2"],
  "B3.1": ["man_comment_b31"],
  B5: ["man_comment_b5_1", "man_comment_b5_2"],
  "D1.1": ["man_comment_d11"],
  I1: ["man_comment_i1_2"],
};

export const MANUAL_CONTROL_COLUMNS = {
  "03": ["man_comment_03"],
  A2: ["man_input_a2"],
  A3: ["man_input_a3_file", "man_input_a3_invoice"],
  A4: ["man_input_a4"],
  A5: ["man_input_a5"],
  A6: ["man_input_a6"],
  A7: ["man_input_a7"],
  A8: ["man_input_a8"],
  B1: ["man_comment_b1"],
  B2: ["man_comment_b2"],
  "B3.1": ["test_b31", "man_comment_b31"],
  "B3.2": ["man_comment_b32"],
  "B3.3": ["man_comment_b33"],
  B4: ['man_amount_cca'],
  B6: ["man_input_b6_1", "man_input_b6_2"],
  B7: ["man_comment_b7"],
  "D1.1": ["man_comment_d11"],
  "D1.2": ["man_comment_d12"],
  D2: ["man_comment_d2"],
  D3: ["man_input_d3"],
  D4: ["man_amount_pca"],
  E1: ["man_input_e1"],
  I1: [null, "man_comment_i1_1"],
  I2: [
    "man_input_i2_1",
    "man_input_i2_2",
    "man_input_i2_3",
    "man_input_i2_4",
    "man_input_i2_5",
    "man_input_i2_6",
    "man_input_i2_7"
  ],
  J1: [
    "man_input_j1_affect_rst",
    "man_input_j1_augmentation",
    "man_input_j1_diminution",
  ],
  J2: ["man_input_j2"],
  J3: ["man_input_j32_immo_total"],
};

const roundNumbers = (number, fractionDigits = 2) => {
  return parseFloat(Math.round((number * 100) / 100).toFixed(fractionDigits));
};

export const calculateEcart = (row, column) => {
  if (!row[column]) return row.balance;
  const diff = Math.abs(parseFloat(row.balance) - parseFloat(row[column]));
  return roundNumbers(diff);
};
export const ECART_COLUMNS = {
  A3: ["man_input_a3_file", "man_input_a3_invoice"],
  B4: ["man_amount_cca"],
  D3: ["man_input_d3"],
  D4: ["man_amount_pca"],
  E1: ["man_input_e1"],
  J2: ["man_input_j2"],
};

export const isBalanceMatching = (
  row,
  testId,
  balanceColumn = "Echéancier"
) => {
  if (
    roundNumbers(parseFloat(row.balance) - parseFloat(row[balanceColumn])) === 0
  )
    return "OK";
  return "KO";
};

function safeParseFloat(input) {
  if (!input) return 0;
  const result = parseFloat(input);
  if (isNaN(result)) return 0;
  return result;
}

export const performManualControl = {
  A2: {
    0: (row) => isBalanceMatching(row, "a2", MANUAL_CONTROL_COLUMNS.A2[0]),
  },
  A3: {
    0: (row) => {
      if (calculateEcart(row, ECART_COLUMNS["A3"][0]) === 0) return "OK";
      return "KO";
    },
    1: (row) => {
      if (calculateEcart(row, ECART_COLUMNS["A3"][1]) === 0) return "OK";
      return "KO";
    },
  },
  A4: (row) => isBalanceMatching(row, "a4", MANUAL_CONTROL_COLUMNS.A4[0]),
  A5: (row) => isBalanceMatching(row, "a5", MANUAL_CONTROL_COLUMNS.A5[0]),
  A6: (row) => isBalanceMatching(row, "a6", MANUAL_CONTROL_COLUMNS.A6[0]),
  A7: (row) => isBalanceMatching(row, "a7", MANUAL_CONTROL_COLUMNS.A7[0]),
  A8: (row) => isBalanceMatching(row, "a8", MANUAL_CONTROL_COLUMNS.A8[0]),
  B4: (row) => {
    if (calculateEcart(row, ECART_COLUMNS["B4"][0]) === 0) return "OK";
    return "KO";
  },
  B6: (row) => {
    if (
      roundNumbers(
        row.balance -
        safeParseFloat(row["man_input_b6_1"]) -
        safeParseFloat(row["man_input_b6_2"])
      ) === 0
    )
      return "OK";
    return "KO";
  },
  D4: (row) => {
    if (calculateEcart(row, ECART_COLUMNS["D4"][0]) === 0) return "OK";
    return "KO";
  },
  D3: (row) => {
    if (calculateEcart(row, ECART_COLUMNS["D3"][0]) === 0) return "OK";
    return "KO";
  },
  E1: (row) => {
    if (calculateEcart(row, ECART_COLUMNS["E1"][0]) === 0) return "OK";
    return "KO";
  },
  I2: {
    0: (row) => {
      if (
        (row.balance -
          (safeParseFloat(row.man_input_i2_1) +
            safeParseFloat(row.man_input_i2_2) +
            safeParseFloat(row.man_input_i2_3) +
            safeParseFloat(row.man_input_i2_4) +
            safeParseFloat(row.man_input_i2_5))) === 0
      ) return "OK";
      return "KO";
    },
    1: (row) => {
      if (
        row.balance - safeParseFloat(row["man_input_i2_6"]) === 0
      ) return "OK";
      return "KO";
    },
    2: (row) => {
      if (
        row.balance - safeParseFloat(row["man_input_i2_7"]) === 0
      ) return "OK";
      return "KO";
    },
  },
  J1: (row) => {
    const prevBalance =
      safeParseFloat(row.balance_previous_year) +
      safeParseFloat(row.man_input_j1_affect_rst) +
      safeParseFloat(row.man_input_j1_augmentation) +
      safeParseFloat(row.man_input_j1_diminution);
    if (roundNumbers(prevBalance - row.balance_current_year) === 0) return "OK";
    return "KO";
  },
  J2: (row) => {
    if (calculateEcart(row, ECART_COLUMNS["J2"][0]) === 0) return "OK";
    return "KO";
  },
  J3: {
    1: (row) => {
      if (row.balance + safeParseFloat(row.man_input_j32_immo_total) === 0)
        return "OK";
      return "KO";
    },
  },
};

export const DETAIL_TABLE_NAMES = {
  "01": ["balance_generale"],
  "02": ["balance_generale"],
  "03": null,
  "B3.2": null,
  A7: ["ZFIR23"],
  B4: ["ZFIR20", "ZFIR23"],
  B7: ["ZFIR20", "ZFIR23"],
  "D1.2": null,
  "D2": null,
  K1: null,
  F1: ["ZFIR20", "ZFIR22"],
  F2: null,
  J1: null,
};

export const HIDDEN_DETAIL_COLUMNS = {
  "04": [SUPPLIER_CODE],
  A1: [SUPPLIER_CODE],
  A2: ["balance_previous_year", "variation_net", SUPPLIER_CODE],
  A3: [SUPPLIER_CODE],
  A4: [SUPPLIER_CODE],
  A5: [SUPPLIER_CODE],
  A6: [SUPPLIER_CODE],
  A7: [SUPPLIER_CODE],
  A8: [SUPPLIER_CODE],
  B2: [SUPPLIER_CODE],
  "B3.1": [SUPPLIER_CODE],
  B4: ["Unnamed: 0", SUPPLIER_CODE],
  B7: ["Unnamed: 0", SUPPLIER_CODE],
  F1: ["Unnamed: 0"],
  I1: [SUPPLIER_CODE],
};

export const TABLE_FILTERS = {
  "02": [ACCOUNT],
  "04": [ACCOUNT],
  A1: [ACCOUNT],
  A2: [ACCOUNT],
  A3: [ACCOUNT],
  A4: [ACCOUNT],
  A5: [ACCOUNT],
  A6: [ACCOUNT],
  A7: [ACCOUNT],
  A8: [ACCOUNT],
  B1: [ACCOUNT, SUPPLIER_CODE],
  B2: [ACCOUNT],
  "B3.1": [EOTP],
  B4: {
    0: [ACCOUNT],
    1: [ENTITY_CODE],
  },
  B5: [ACCOUNT, "affectation"],
  B6: [ACCOUNT],
  B7: [ACCOUNT],
  "D1.1": [EOTP],
  D2: [ACCOUNT],
  D3: [ACCOUNT],
  E1: [ACCOUNT],
  F1: [ACCOUNT, "asset_category"],
  I1: [ACCOUNT],
  J2: [ACCOUNT],
  J3: [ACCOUNT],
  "05": [EOTP],
  "06": [EOTP],
};

export const detailsRestricted = {
  B4: {balance: 0, amount_cca: 1},
  B7: {balance: 0, rent_amount: 1},
  F1: {balance: 0, immo_total: 1},
};
